<widget-header
  [name]="widgetName"
  [editable]="isEditable">

  <attribute-help-text slot="append"
                       attribute="description"
                       [attributeScope]="'Project'" />

  <widget-menu slot="menu"
    [resource]="resource" />
</widget-header>

<turbo-frame class="grid--widget-content" [id]="frameId" [src]="src" loading="lazy" />
